// extracted by mini-css-extract-plugin
export default {"App":"App_App__oFG66","mainTitle":"App_mainTitle__Msx5c"};